import React from "react";
import numeral from "numeral";
import { TierLabels } from "@seabrookstudios/pitch2table-core";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { usePublisherFitForGameV2 } from "@seabrookstudios/pitch2table";

/**
 * @type {Record<import("@seabrookstudios/pitch2table-core").FitScoreLabel, "primary"|"secondary"|"info"|"warning"|"success"|"error">}
 */
const TierColors = {
  Tier1: "primary",
  Tier2: "secondary",
  Tier3: "info",
  Tier4: "warning",
  Unaligned: "error",
};

/**
 * @param {Object} props
 * @param {string|undefined} props.tier
 * @param {number|undefined} props.score
 */
export const ResearchPublisherFitTierChip = ({ tier, score }) => {
  if (!tier) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <Chip label="No Data" size="small" variant="filled" color="default" />
      </Box>
    );
  }

  const scorePct = typeof score === "number" ? numeral(score).format("%") : null;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
      <Chip label={TierLabels[tier]} size="small" variant="filled" color={TierColors[tier]} />
      {scorePct !== null && (
        <Typography variant="body2" color="text.secondary" component="span">
          ({scorePct})
        </Typography>
      )}
    </Box>
  );
};

/**
 * @param {Object} props
 * @param {import("@seabrookstudios/pitch2table-core").PublisherId} props.publisherId
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 * @param {"filled"|"outlined"} props.variant
 */
export const PublisherFitChip = ({ publisherId, gameId, variant = "filled" }) => {
  const { data: fitScores = [] } = usePublisherFitForGameV2(gameId);
  const fitScore = fitScores.find((f) => f.publisherId === publisherId);
  const tier = fitScore?.label;
  const score = fitScore?.score;

  if (!tier) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <Chip label="No Data" variant={variant} color="default" />
      </Box>
    );
  }

  const scorePct = typeof score === "number" ? numeral(score).format("%") : null;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
      <Chip label={`${TierLabels[tier]} (${scorePct})`} variant={variant} color={TierColors[tier]} />
    </Box>
  );
};
